import React from 'react';
import {Link} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import Query from '../../components/Query';
import {QUERY_MATERIAL_LIST} from './graphql';

const MaterialList = ({match}) => {
  const query = useQuery(QUERY_MATERIAL_LIST);

  return (
    <div className="container">
      {Query(query) || (
        <div className="row g-2 g-md-4 py-4">
          {query.data.materialList.map(item => (
            <Link to={`${match.url}/${item.id}`} key={item.id} className="col-6 col-md-4 col-xl-3">
              <div
                className="ratio ratio-1x1 bg-white rounded bg"
                style={{backgroundSize: 'cover', backgroundImage: `url(${item.cover.path})`}}
              />
              <div className="mt-2">{item.name}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default MaterialList;
